import { NavLink } from "react-router-dom";
import Icon from "./Icon";
import { Logo } from "./Logo";
import { cn } from "../../lib/utils";

const CLUB_MENU = [
  { label: "داشبورد", path: "/club/dashboard", icon: "dashboard" },
  { label: "پروفایل باشگاه", path: "/club/profile", icon: "club" },
  { label: "بازیکنان", path: "/club/players", icon: "users" },
  { label: "تورنمنت‌ ها", path: "/club/tournaments", icon: "trophy" },
  { label: "درخواست انتقال", path: "/club/transfer-requests", icon: "arrowLeft" },
  { label: "مسابقات", path: "/club/matches", icon: "ball" },
  { label: "تیکت‌ ها", path: "/club/tickets", icon: "ticket" },
  { label: "مالی", path: "/club/financials", icon: "wallet" },
  { label: "امنیت حساب", path: "/club/security", icon: "shield" },
];

export default function ClubSidebar({ mobile = false }) {
  return (
    <aside
      dir="rtl"
      className={cn(
        "relative flex h-full shrink-0 flex-col overflow-hidden rounded-[2rem] bg-ink text-white",
        "shadow-[0_30px_70px_-28px_rgba(7,21,15,0.75)] ring-1 ring-white/5",
        mobile ? "w-72" : "w-[260px]"
      )}
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="pitch-stripes absolute inset-0" />
        <div className="absolute -right-24 -top-24 h-56 w-56 rounded-full bg-emerald-500/20 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-64 w-64 rounded-full bg-floodlight/10 blur-3xl" />
      </div>

      <div className="relative z-10 flex h-[72px] shrink-0 items-center border-b border-white/10 px-5">
        <Logo size="sm" />
      </div>

      <div className="relative z-10 px-4 pt-4">
        <div className="flex items-center gap-3 rounded-3xl border border-white/10 bg-gradient-to-l from-floodlight/15 to-transparent p-3">
          <div className="grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-floodlight text-ink">
            <Icon name="shield" className="h-5 w-5" />
          </div>

          <div className="min-w-0">
            <p className="truncate text-xs font-extrabold text-white">
              پنل باشگاه
            </p>
            <p className="mt-1 truncate text-[10px] text-white/40">
              مدیریت تیم و بازیکنان
            </p>
          </div>
        </div>
      </div>

      <nav className="relative z-10 flex-1 space-y-1 overflow-y-auto px-3 py-4">
        {CLUB_MENU.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              cn(
                "group flex items-center gap-3 rounded-full px-3 py-2.5 text-sm font-bold transition-all duration-300",
                isActive
                  ? "bg-floodlight text-ink shadow-lime"
                  : "text-white/60 hover:bg-white/[0.07] hover:text-white"
              )
            }
          >
            {({ isActive }) => (
              <>
                <span
                  className={cn(
                    "grid h-9 w-9 shrink-0 place-items-center rounded-full transition-all",
                    isActive
                      ? "bg-ink/10"
                      : "bg-white/[0.05] group-hover:bg-white/10"
                  )}
                >
                  <Icon name={item.icon} className="h-[18px] w-[18px]" />
                </span>
                <span className="truncate">{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="relative z-10 border-t border-white/10 p-3">
        <div className="rounded-2xl bg-white/[0.05] px-3 py-3 text-center text-[10px] font-medium text-white/35">
          پنل مدیریت باشگاه
        </div>
      </div>
    </aside>
  );
}
